import { BasicCard, BasicCardProps } from '../basic-card';

export const FireImportantCharacteristics = () => {
  const importCharacteristics: BasicCardProps[] = [
    {
      title: 'Requires full disclosure of property details',
      content:
        'Misrepresentation of facts is a serious offence in Fire Insurance as it requires reimbursement of properties lost and contents. Thus, each policy requires a strict and full description of each item that comprises the property. Any wrong information will make the contract void',
    },
    {
      title: 'Personal Insurance Contract',
      content:
        'The policy agreement is a personal contract with the policyholder and the insurer. They are also part of the policy and their actions are liable to the insurer.  The claims can also be made only by the person mentioned in the document.',
    },
    {
      title: 'Fire Needs to be The Only Cause of Loss',
      content:
        'The damage to the insured property must be caused by accidental and actual fires only. Any form of damage caused by the destruction of the insured property that violates these principles will be compensated by the policy.',
    },
    {
      title: 'Annual Contract',
      content:
        'Fire Insurance policies are year to year contracts that must be renewed annually. If not renewed, the insurer is not liable to pay the insured any compensation after expiration. ',
    },
    {
      title: 'Insurable Interest',
      content:
        'The insured needs to have a vested interest in the property that is being considered for coverage. Its damage or non-damage should have a direct effect on the insured’s life. Only then is one eligible for getting fire insurance.',
    },
    {
      title: 'Principle of Indemnity',
      content:
        'Fire insurance is an agreement for only damage caused by a fire to the covered property. In the case of a fire that causes zero damage, the insurer is not liable to pay any sum to the insured.',
    },
  ];
  return (
    <div className="bg-surface-grey py-12">
      <div className="container">
        <h3 className="lg:heading-3 heading-4 mb-6  lg:text-center">Important characteristics of fire insurance</h3>
        <div className="flex grid-cols-3 gap-3 overflow-x-auto lg:grid">
          {importCharacteristics.map((card, idx) => {
            return <BasicCard {...card} className="min-w-[85%] lg:w-full" key={idx} />;
          })}
        </div>
      </div>
    </div>
  );
};
